export default __webpack_public_path__ + "static/182-ff514149b534e62b2123d7ec1ce51691.jpg";